export default __webpack_public_path__ + "static/media/P-047.a0aa3104.png";